import * as yup from "yup"
import { RegExps } from "@theguarantors/validations"

export const REQUIRED = "Required"
export const INVALID_EMAIL = "Invalid email address"
export const INVALID_NUMBER = "Please enter a positive number"
export const INVALID_ZIP_CODE = "Please enter a 5-digit or 9-digit zip code"

const email = yup
  .string()
  .required(REQUIRED)
  .email(INVALID_EMAIL)

const addressStreet = yup
  .string()
  .trim()
  .required(REQUIRED)

const apartmentNumber = yup.string().trim()

const addressCity = yup
  .string()
  .trim()
  .required(REQUIRED)

const addressState = yup.string().required(REQUIRED)

const zipCode = yup
  .string()
  .required(REQUIRED)
  .matches(RegExps.zipCode, INVALID_ZIP_CODE)

const landlordCompany = yup.string().trim()

const landlordName = yup.string().trim()

const landlordEmail = yup.string().email(INVALID_EMAIL)

const brokerName = yup.string().trim()

const brokerEmail = yup.string().email(INVALID_EMAIL)

const annualIncome = yup
  .string()
  .required(REQUIRED)
  .test("annual_income", INVALID_NUMBER, val => Number(val) > 0)

const liquidAsset = yup
  .string()
  .required(REQUIRED)
  .test("liquid_assets", INVALID_NUMBER, val => Number(val) > 0)

export const validationSchema = {
  email,
  addressStreet,
  apartmentNumber,
  addressCity,
  addressState,
  zipCode,
  landlordCompany,
  landlordName,
  landlordEmail,
  brokerName,
  brokerEmail,
  annualIncome,
  liquidAsset
}
